// extracted by mini-css-extract-plugin
module.exports = {"container":"ListEmpty_container__32KzN","text":"ListEmpty_text__12xQY"};